import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';

export type CampaignHubTab = 'basics' | 'respondent' | 'invitations' | 'responses' | 'report';

interface CampaignHubTabsProps {
  active: CampaignHubTab;
  onChange: (tab: CampaignHubTab) => void;
}

const TABS: CampaignHubTab[] = ['basics', 'respondent', 'invitations', 'responses', 'report'];

/** Tab navigation for campaign detail hub. */
export const CampaignHubTabs: React.FC<CampaignHubTabsProps> = ({ active, onChange }) => {
  const { t } = useLanguage();

  return (
    <div className="tab-bar mb-6">
      <nav className="flex gap-1 overflow-x-auto items-end" aria-label="Campaign hub tabs">
        {TABS.map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() => onChange(tab)}
            className={`tab-button inline-flex items-center gap-2 ${active === tab ? 'tab-button-selected' : ''}`}
          >
            {t(`assessmentEngine.hub.tab.${tab}`)}
          </button>
        ))}
      </nav>
    </div>
  );
};
